module.exports = __webpack_public_path__ + "img/Starter motor.e4481ebf.jpg";